<div class="camera-container">
  <!-- Flash effect overlay -->
  <div class="flash" *ngIf="flashActive"></div>

  <!-- Countdown overlay -->
  <div *ngIf="countdown > 0" class="countdown-overlay">
    <div class="countdown">{{countdown}}</div>
  </div>

  <!-- Camera loading state -->
  <div *ngIf="!isCameraReady" class="camera-loading-overlay">
    <div class="loading-indicator">
      <mat-icon>sync</mat-icon>
      <span>Loading camera...</span>
    </div>
  </div>

  <!-- Instructions overlay - only shown initially -->
  <div *ngIf="showControls && !isRecording && !captureInProgress && isCameraReady" class="instructions-overlay" @fadeInOut>
    <div class="instruction">
      <mat-icon>touch_app</mat-icon>
      <span>Tap anywhere to display controls</span>
    </div>
  </div>
  
  <!-- Size limit warning - conditionally displayed based on isSms -->
  <div *ngIf="isVideoMode && showControls && !isRecording && this.data?.isSms && isCameraReady" class="limit-notice-overlay" @fadeInOut>
    <div class="limit-notice">
      <mat-icon>warning</mat-icon>
      <span>Videos over 600KB (about 20 seconds) may be sent as links.</span>
    </div>
  </div>

  <!-- Recording indicator with file size information - always visible during recording -->
  <div *ngIf="isRecording" class="recording-indicator" [class.warning]="fileSizeWarning && data?.isSms" [class.danger]="overSizeLimit && data?.isSms">
    <div class="recording-dot"></div>
    <span class="recording-time">{{formatTime(recordingTime)}}</span>
    <span class="file-size" [class.warning-text]="fileSizeWarning && data?.isSms" [class.real-size]="useActualSize">
      {{formatFileSize(estimatedFileSize)}}
    </span>
    <span class="max-size" *ngIf="(fileSizeWarning || overSizeLimit) && data?.isSms">
      (limit: 600KB)
    </span>
    <span class="over-limit-warning" *ngIf="overSizeLimit && data?.isSms">Size limit exceeded! May be sent as links</span>
  </div>

  <!-- Camera feed -->
  <video #video autoplay muted playsinline [class.selfie-mode]="facingMode === 'user'"></video>
  <canvas #canvas style="display: none;"></canvas>

  <!-- Controls Bar -->
  <div class="controls-overlay" [class.visible]="showControls" @fadeInOut>
    <div class="top-controls" *ngIf="!isRecording">
      <button mat-icon-button class="close-button" (click)="closeDialog()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>

      <button mat-icon-button (click)="switchCamera()" matTooltip="Switch Camera">
        <mat-icon>flip_camera_ios</mat-icon>
      </button>
    </div>
    <div *ngIf="isRecording"></div>

    <div class="bottom-controls">
      <button mat-icon-button class="mode-switch" (click)="switchMode()" matTooltip="Switch Mode" [disabled]="!isCameraReady">
        <mat-icon>{{ isVideoMode ? 'photo_camera' : 'videocam' }}</mat-icon>
      </button>

      <!-- Photo Mode Button -->
      <button *ngIf="!isVideoMode" matRipple class="capture-button" (click)="capturePhoto(false)" [disabled]="captureInProgress || !isCameraReady">
        <div class="capture-inner" [class.disabled]="!isCameraReady"></div>
      </button>

      <!-- Video Mode Button -->
      <button *ngIf="isVideoMode" matRipple class="capture-button" [class.recording]="isRecording" [class.disabled]="!isCameraReady" (click)="toggleVideoRecording()" [disabled]="!isCameraReady">
        <div class="capture-inner" [class.recording-inner]="isRecording" [class.disabled]="!isCameraReady"></div>
      </button>

      <button *ngIf="!isVideoMode" mat-icon-button class="timer-button" (click)="capturePhoto(true)" [disabled]="!isCameraReady" matTooltip="3s Timer">
        <mat-icon>timer</mat-icon>
      </button>
    </div>
  </div>
</div>
